import React from 'react';
import { utcTimeToUserTime } from 'lib/utils/time';
import { useAuth } from 'lib/context';
import { NOTIFICATION_TYPES } from '../types';
import { ISingleNotification } from 'lib/api/notifications/getNotifications';
import { checkIfFreemium } from 'lib/utils/functions';

export const NotificationText = ({
  notification,
}: {
  notification: ISingleNotification;
}) => {
  const { userData } = useAuth();
  const isFreemium = checkIfFreemium(userData);
  const createdAt = utcTimeToUserTime(
    notification.createdAt,
    userData,
    'YYYY-MM-DDTHH:mm:ss.000Z'
  );
  switch (notification.type?.toUpperCase()) {
    case NOTIFICATION_TYPES.QUOTES:
      return (
        <>
          <b>Approved items.</b>
        </>
      );
    case NOTIFICATION_TYPES.FILES:
      return (
        <>
          <b>{`${notification.senderName}`}</b> shared{' '}
          <b>{`‘${notification.entityName}’`}</b> with you.
        </>
      );
    case NOTIFICATION_TYPES.BOARDS:
      return (
        <>
          <b>{`${notification.senderName}`}</b> shared the board{' '}
          <b>{`‘${notification.entityName}’`}</b> with you.
        </>
      );
    case NOTIFICATION_TYPES.SALES:
      return (
        <>
          <b>New Test Drive Scheduled</b>
        </>
      );
    case NOTIFICATION_TYPES.CTA:
      return (
        <>
          {notification.senderName !== '' ? (
            <b>{`${notification.senderName} clicked ${notification?.meta?.ctaButtonText} on your video ${notification.entityName}.`}</b>
          ) : (
            <b>{`${notification?.meta?.ctaButtonText} button on your video ${notification.entityName} was clicked.`}</b>
          )}
        </>
      );
    case NOTIFICATION_TYPES.REPLY:
      return (
        <>
          {notification.senderName !== '' ? (
            <b>{`${
              notification.senderName
            } sent a video reply in response to your video ${
              notification?.entityName
            } on ${createdAt.substring(0, 10)} at ${createdAt.substring(
              11,
              16
            )}.`}</b>
          ) : (
            <b>
              {`You received a video reply in response to your video ${
                notification?.entityName
              } on ${createdAt.substring(0, 10)} at ${createdAt.substring(
                11,
                16
              )}.`}
              .`
            </b>
          )}
        </>
      );
    case NOTIFICATION_TYPES.VIEW:
      return (
        <>
          {notification.senderName !== '' && !isFreemium ? (
            <b>{`Your video ${notification.entityName} was viewed by ${
              notification.senderName
            } on ${createdAt.substring(0, 10)} at ${createdAt.substring(
              11,
              16
            )}.`}</b>
          ) : (
            <b>{`Your video ${
              notification.entityName
            } was viewed on ${createdAt.substring(
              0,
              10
            )} at ${createdAt.substring(11, 16)}.`}</b>
          )}
        </>
      );
    case NOTIFICATION_TYPES.EMAIL_NOT_DELIVERED:
      return (
        <>
          {notification.senderName !== '' ? (
            <b>{`Your email containing the video ${notification.entityName}  failed to deliver to ${notification.senderName}`}</b>
          ) : (
            <b>{`Your email containing the video ${notification.entityName} failed to deliver`}</b>
          )}
        </>
      );

    case NOTIFICATION_TYPES.MESSAGES:
      return (
        <>
          {notification.meta.header && <b>{notification.meta.header}</b>}
          {notification.meta.text && <div>{notification.meta.text}</div>}
        </>
      );
    case NOTIFICATION_TYPES.REACTIONS_COMMENTS:
      return (
        <>
          {notification?.meta?.reactionType === '1' && (
            <b>
              {notification.senderName} commented on your video{' '}
              {notification.entityName}.
            </b>
          )}
          {notification?.meta?.reactionType === '2' && (
            <b>
              {' '}
              {notification.senderName} reacted to your video{' '}
              {notification.entityName}.
            </b>
          )}
          {notification?.meta?.reactionType === '3' && (
            <b>
              {' '}
              {notification.senderName} reacted and left a comment on your video{' '}
              {notification.entityName}.
            </b>
          )}
        </>
      );
    case NOTIFICATION_TYPES.PUSHED_TO_VDP:
      return (
        <>
          <b>{`${notification.senderName} pushed video ${notification.entityName} to the ${notification?.meta.vehicleName}
             #VIN: ${notification?.meta.vin} VDP`}</b>
        </>
      );

    case NOTIFICATION_TYPES.LIVE:
      return (
        <>
          <b>{`Your guest just joined ${notification.entityName}.`}</b>
        </>
      );
    case NOTIFICATION_TYPES.VIDEO_DELETE:
      return (
        <>
          <b>{`${notification.senderName} requested video deletion to be prolonged for video: ${notification?.entityName}`}</b>
        </>
      );
    case NOTIFICATION_TYPES.REPORTS:
      return (
        <>
          <b>{`The report ${
            notification.actionId
          } was shared by you on ${createdAt.substring(
            0,
            10
          )} at ${createdAt.substring(11, 16)}.`}</b>
        </>
      );
    case NOTIFICATION_TYPES.EMAIL_OPENED:
      return (
        <>
          <b>{`${notification.senderName} has opened you video video: ${notification?.entityName}`}</b>
        </>
      );
    default:
      return null;
  }
};
